module.exports = __webpack_public_path__ + "img/cut_bed.6c89733f.png";